import request from '@/utils/request';
export function getMemberByToken() {
  return request.post("/api/basic/member/login/getMemberByToken");
}

export function getUserMenu(params) {
  return request.post("/api/basic/authFunc/selSubFuncListByParam", { ...params });
}
